$(document).ready(function(){


	// global varinats
	var strHtml = '';
	var arrStates_US = [];
	var arrStates_MM_US = [];
	var arrStates_MMAK_US = [];

	//init html
	strHtml = prepareHtml();

	$(window).on('load',function(){

		// prepare html
		$('#shoplist-target').html(strHtml);

		// prepare state options
		$('#select-states').html(makeStatesOptionHtml_US());
		$('#select-states-MM-US').html(makeStatesOptionHtml_MM_US());
		$('#select-states-MMAK-US').html(makeStatesOptionHtml_MMAK_US());


		// original list
		let $listOrg = $('#shoplist-target [data-category]');


		// Brand, Area and State
		$('.shoplist-selectbox').on('change', function(e) {

			let $strBrand = $('#select-brand').val();
			let $strArea = $('#select-area').val();

			let $strState = '';
			if($strBrand === 'MM' && $strArea === 'US'){
				$strState = $('#select-states-MM-US').val();
			}else if($strBrand === 'MMAK' && $strArea === 'US'){
				$strState = $('#select-states-MMAK-US').val();
			}else{
				$strState = $('#select-states').val();
			}

			$listOrg.fadeOut().promise().done(function() {
				// filter
				filterAll($strBrand, $strArea, $strState);
				// scroll top
				$("#shoplist-box").animate({ scrollTop: 0 }, 0);
			});

		});

	});







	$('.shoplist-selectbox').on('change', function() {

		// 選択されたオプションの値を取得
		let selectedValue = $(this).val();

		// 選択された値が "All" である場合
		if (selectedValue === "all") {
			// 一つ目のオプションに hidden 属性が設定されているか確認
			if ($(this).find("option:first").attr('hidden')) {
				// 一つ目のオプションを選択
				$(this).val($(this).find("option:first").val());
			}
		}

	});


	$('#select-brand').on('change', function() {

		// Brandが変更された場合、AreaとStateはリセット

		$('#select-area').prop('selectedIndex', 0);

		$('#select-wrapper-states').css("display", 'none');
		$('#select-states').prop('selectedIndex', 0);

		$('#select-wrapper-states-MM-US').css("display", 'none');
		$('#select-states-MM-US').prop('selectedIndex', 0);

		$('#select-wrapper-states-MMAK-US').css("display", 'none');
		$('#select-states-MMAK-US').prop('selectedIndex', 0);

	});


	$('#select-area').on('change', function() {

		let selectedArea = $(this).val();
		let selectedBrand = $('#select-brand').val();

		if(selectedBrand === "" && selectedArea != "US"){

			$('#select-wrapper-states').css("display", 'none');
			$('#select-states').prop('selectedIndex', 0);

			$('#select-wrapper-states-MM-US').css("display", 'none');
			$('#select-states-MM-US').prop('selectedIndex', 0);

			$('#select-wrapper-states-MMAK-US').css("display", 'none');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

		}else if(selectedBrand === "" && selectedArea === "US"){

			$('#select-wrapper-states').css("display", 'block');
			$('#select-states').css("display", 'block');

			$('#select--wrapper-states-MM-US').css("display", 'none');
			$('#select-states-MM-US').prop('selectedIndex', 0);

			$('#select--wrapper-states-MMAK-US').css("display", 'none');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

		}else if(selectedBrand === "MM" && selectedArea === "US"){

			$('#select-wrapper-states').css("display", 'none');
			$('#select-states').prop('selectedIndex', 0);

			$('#select-wrapper-states-MM-US').css("display", 'block');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

			$('#select-wrapper-states-MMAK-US').css("display", 'none');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

		}else if(selectedBrand === "MMAK" && selectedArea === "US"){

			$('#select-wrapper-states').css("display", 'none');
			$('#select-states').prop('selectedIndex', 0);

			$('#select-wrapper-states-MM-US').css("display", 'none');
			$('#select-states-MM-US').prop('selectedIndex', 0);

			$('#select-wrapper-states-MMAK-US').css("display", 'block');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

		}else{

			$('#select-wrapper-states').css("display", 'none');
			$('#select-states').prop('selectedIndex', 0);

			$('#select-wrapper-states-MM-US').css("display", 'none');
			$('#select-states-MM-US').prop('selectedIndex', 0);

			$('#select-wrapper-states-MMAK-US').css("display", 'none');
			$('#select-states-MMAK-US').prop('selectedIndex', 0);

		}


	});









	/* functions */

	function prepareHtml(){

		// load file
		let data = new XMLHttpRequest();
//		data.open("GET", "./gmap/retailers.txt", false);
		data.open("GET", "//miekomintz.com/cdn/shop/files/retailers.txt?v=2469664073772392571", false);
		data.send(null);

		//   let lines = data.responseText.split('\r\n');
		let lines = data.responseText.split('\n');

		lines = lines.map(x => x.split('\t'));

		// sort
		lines.sort(function(a, b) {

			// area
			if(a[1] != b[1]){
				if (a[1] < b[1]) {
					return 1;
				} else {
					return -1;
				}
			}

			// country
			if(a[2] != b[2]){
				if (a[2] < b[2]) {
					return 1;
				} else {
					return -1;
				}
			}

			// state
			if(a[3] != b[3]){
				if (a[3] > b[3]) {
					return 1;
				} else {
					return -1;
				}
			}

			// name
			if(a[0] != b[0]){
				if (a[0] > b[0]) {
					return 1;
				} else {
					return -1;
				}
			}

		})



		let lastArea = '';
		let lastCountry = '';
		let lastState = '';

		// 選択されたBrand名
		let = selectedBrand = '';

		for (var i = 1 ; i < lines.length ; i++){

			let vals = lines[i];
			let name = vals[0];
			let area = vals[1];
			let country = vals[2];
			let state = vals[3];
			let address = vals[4].replace(/"/g, '')
			let tel = vals[5];
			let url = vals[6].replace(/"/g, '');

			let mm = vals[7];
			let mmak = vals[8];

			let lat = vals[9];
			let lng = vals[10];

			let map = vals[11].replace(/\s+/g, "");

			
			// プルダウンの要素
			if(country == 'US'){
				arrStates_US.push(state);
				// MM
				if(mm === '1'){
					arrStates_MM_US.push(state);
				}
				// MMAK
				if(mmak === '1'){
					arrStates_MMAK_US.push(state);
				}
			}
			
			// state changed
			if(isStateChanged(state, lastState)){

				if(i != 1){
					// state FOOTER
					strHtml += '</div>';
					strHtml += '</ul>';
				}


				if(country == 'US'){
					arrStates_US.push(state);
					// MM
					if(mm === '1'){
						arrStates_MM_US.push(state);
					}
					// MMAK
					if(mmak === '1'){
						arrStates_MMAK_US.push(state);
					}
				}

				if(isAreaChanged(area, lastArea)){

					if(i != 1){
						// country FOOTER
						strHtml += '</div><!-- end of .country-wrapper -->';
						// area FOOTER
						strHtml += '</div><!-- end of .area-wrapper -->';
					}
					// area HEADER
					strHtml += '<div class="area-wrapper ' + area + '" data-category="' + area + '">';
				}

				if(isCountryChanged(country, lastCountry)){

					if(i != 1 && !isAreaChanged(area, lastArea)){
						// country FOOTER
						strHtml += '</div><!-- end of .country-wrapper -->';
					}
					// country HEADER
					strHtml += '<div class="country-wrapper ' + country + '" data-category="' + country + '">';
					strHtml += '<h1 class="shoplist-title1">' + getCountryString(country) + '</h1>';
				}

				//state HEADER
				strHtml += '<div class="state-wrapper ' + state + '"  data-category="' + state + '">';
				strHtml += '<h2 class="shoplist-title2">' + state + '</h2>';
				strHtml += '<ul id="sortable-shoplist" class="shoplist-stores">';

			}

			strHtml += '<li class="' + getBrandFilterString(mm, mmak) + '" data-category="' + getBrandFilterString(mm, mmak) + '">';
			strHtml += '<p class="store-name">' + name + '</p>';
			strHtml += '<p class="store-address">' + address + '</p>';
			strHtml += '<p class="store-tel">TEL: ' + tel + '</p>';
			strHtml += '<div class="store-nav">';

			// url
			if(url != ''){
				strHtml += '<a href="';
				strHtml += url;
				strHtml += '" class="store-nav-btn" target="_blank">Website</a>';
			}

			// map
			if(map != ''){
				strHtml += '<a href="';
				strHtml += map;
				strHtml += '" class="store-nav-btn" target="_blank">Map</a>';
			}else{
				strHtml += '<a href="https://www.google.com/maps?q=';
				strHtml += lat + ',' + lng
				strHtml += '" class="store-nav-btn" target=_blank"">Map</a>';
            }
          
			strHtml += '</div>';
			strHtml += '</li>';

			lastArea = area;
			lastCountry = country;
			lastState = state;

			// end of loop
			if(i == lines.length-1){
				// state FOOTER
				strHtml += '</div><!-- end of .state-wrapper(last loop) -->';
				// country FOOTER
				strHtml += '</div><!-- end of .country-wrapper(last loop) -->';
				// area FOOTER
				strHtml += '</div><!-- end of .area-wrapper(last loop) -->';
			}


		}

		// プルダウンから重複を削除
		arrStates_US = [...new Set(arrStates_US)];
		arrStates_MM_US = [...new Set(arrStates_MM_US)];
		arrStates_MMAK_US = [...new Set(arrStates_MMAK_US)];
		
		return strHtml;

	}






	function makeStatesOptionHtml_US(){

		let result = '';
		result += '<option value="" hidden>States</option><option value="all" class="select-opt-all">All</option>';

		$.each(arrStates_US, function(index, value) {
			result += '<option value="' + value + '">' + value + '</option>';
		});

		return result;

	}

	function makeStatesOptionHtml_MM_US(){

		let result = '';
		result += '<option value="" hidden>States</option><option value="all" class="select-opt-all">All</option>';

		$.each(arrStates_MM_US, function(index, value) {
			result += '<option value="' + value + '">' + value + '</option>';
		});

		return result;

	}

	function makeStatesOptionHtml_MMAK_US(){

		let result = '';
		result += '<option value="" hidden>States</option><option value="all" class="select-opt-all">All</option>';

		$.each(arrStates_MMAK_US, function(index, value) {
			result += '<option value="' + value + '">' + value + '</option>';
		});

		return result;
	}


	function filterAll(brand, area, state){

/*
console.log("brand: " + brand);
console.log("area: " + area);
console.log("state: " + state);
*/

		// 最初にすべてを初期化
		let $listOrg = $('#shoplist-target [data-category]');
		$(this).css("display", "block");
		$listOrg.addClass('animate')

		// ***************************
		// 何も指定されていない
		// ***************************
		if(brand === '' && area === '' && state === ''){

			// reset
			let $listOrg = $('#shoplist-target [data-category]');
			$listOrg.addClass('animate')
			$listOrg.css("display", "block");

		// ***************************
		// Brandのみ指定されている場合
		// ***************************
		}else if(brand != '' && area === '' && state === ''){

			let areaElements = $('.area-wrapper');
			// loop of AREA
			areaElements.each(function(index) {

				let showAreaFlg = false;

				// loop of COUNRTY
				let countryElements = $(this).find('.country-wrapper');
				countryElements.each(function(index) {

					let showCountryFlg = false;

					// loop of STATE
					let StateElements = $(this).find('.state-wrapper');
					StateElements.each(function(index) {

						let showStateFlg = false;

						// loop of STORE
						let storeElements = $(this).find('li');
						storeElements.each(function(index) {

							let showStoreFlg = false;

							if($(this).hasClass(brand)){
//							if($(this).is("[data-category*='" + brand + "']")){
								// Store
								showStoreFlg = true;
								// State
								showStateFlg = true;
								// Area
								showAreaFlg = true;
								// Country
								showCountryFlg = true;
							}

							// Store
							if(!showStoreFlg){
								$(this).removeClass('animate');
								$(this).css("display", "none");
							}else{
								$(this).addClass('animate');
								$(this).css("display", "block");
							}


						});

						// State
						if(!showStateFlg){
							$(this).removeClass('animate');
							$(this).css("display", "none");
						}else{
							$(this).addClass('animate');
							$(this).css("display", "block");
						}

					});

					// Country
					if(!showCountryFlg){
						$(this).removeClass('animate');
						$(this).css("display", "none");
					}else{
						$(this).addClass('animate');
						$(this).css("display", "block");
					}


				});

				// Area
				if(!showAreaFlg){
					$(this).removeClass('animate');
					$(this).css("display", "none");
				}else{
					$(this).addClass('animate');
					$(this).css("display", "block");
				}


			});

		// ***************************
		// Brandが空で、Areaが指定されている場合
		// ***************************
		}else if(brand === '' && area != ''){


			//  Stateが空の場合（あるいはall）、Areaのみでフィルターを実施
			if(state === '' || state === 'all'){

				let areaElements = $('.area-wrapper');

				// loop of AREA
				areaElements.each(function(index) {

					let showAreaFlg = false;

					if($(this).hasClass(area)){
//					if($(this).is("[data-category*='" + area + "']")){

						showAreaFlg = true;

						// show all countries in area
						let countryElements = $(this).find('.country-wrapper');
						countryElements.addClass('animate');
						countryElements.css("display", "block");

						// show all states
						let stateElements = $(this).find('.state-wrapper');
						stateElements.addClass('animate');
						stateElements.css("display", "block");

						// show all brands
						let brandElements = $(this).find('li');
						brandElements.addClass('animate');
						brandElements.css("display", "block");

					}

					if(!showAreaFlg){
						$(this).removeClass('animate');
						$(this).css("display", "none");
					}else{
						$(this).addClass('animate');
						$(this).css("display", "block");
					}


				});

			// Stateが指定されているので、AreaとStateの両方でフィルターを実施（Brandなし）
			}else{

				// loop of AREA
				let areaElements = $('.area-wrapper');
				areaElements.each(function(index) {

					let showAreaFlg = false;


					// loop of COUNTRY
					let countryElements = $(this).find('.country-wrapper');
					countryElements.each(function(index) {

						let showCountryFlg = false;

						// loop of STATE
						let stateElements = $(this).find('.state-wrapper');
						stateElements.each(function(index) {

							let showStateFlg = false;

							if($(this).hasClass(state)){
//							if($(this).is("[data-category='" + state + "']")){

								// state
								showStateFlg = true;
								// country
								showCountryFlg = true;
								// Area
								showAreaFlg = true;

								// すべてのStoreを表示
								let storeElements = $(this).find('li');
								storeElements.addClass('animate');
								storeElements.css("display", "block");

							}
							// state
							if(!showStateFlg){
								$(this).removeClass('animate');
								$(this).css("display", "none");
							}else{
								$(this).addClass('animate');
								$(this).css("display", "block");
							}

						});
						// end of STATE loop

						if(!showCountryFlg){
							$(this).removeClass('animate');
							$(this).css("display", "none");
						}else{
							$(this).removeClass('animate');
							$(this).css("display", "block");
						}

					});
					// end of COUNTRY loop


					if(!showAreaFlg){
						$(this).removeClass('animate');
						$(this).css("display", "none");
					}else{
						$(this).addClass('animate');
						$(this).css("display", "block");
					}


				});



			}



		// ***************************
		// BrandとAreaが指定されている（Stateなし）
		// ***************************
		}else if (brand != '' && area != '' && state === ''){

			// loop of AREA
			let areaElements = $('.area-wrapper');
			areaElements.each(function(index) {

				let showAreaFlg = false;

				if($(this).hasClass(area)){


					// loop of COUNTRY
					let countryElements = $(this).find('.country-wrapper');
					countryElements.each(function(index) {

						let showCountryFlg = false;

						// loop of STATE
						let StateElements = $(this).find('.state-wrapper');
						StateElements.each(function(index) {

							let showStateFlg = false;

							// loop of STORE
							let storeElements = $(this).find('li');
							storeElements.each(function(index) {

								let showStoreFlg = false;

								if($(this).hasClass(brand)){
//								if($(this).is("[data-category*='" + brand + "']")){
									// Store
									showStoreFlg = true;
									// State
									showStateFlg = true;
									// Area
									showAreaFlg = true;
									// Country
									showCountryFlg = true;
								}

								// Store
								if(!showStoreFlg){
									$(this).removeClass('animate');
									$(this).css("display", "none");
								}else{
									$(this).addClass('animate');
									$(this).css("display", "block");
								}


							});

							// State
							if(!showStateFlg){
								$(this).removeClass('animate');
								$(this).css("display", "none");
							}else{
								$(this).addClass('animate');
								$(this).css("display", "block");
							}

						});
						// end of STATE loop

						// Country
						if(!showCountryFlg){
							$(this).removeClass('animate');
							$(this).css("display", "none");
						}else{
							$(this).addClass('animate');
							$(this).css("display", "block");
						}

					});
					// end of COUNTRY loop

				}

				// area
				if(!showAreaFlg){
					$(this).removeClass('animate');
					$(this).css("display", "none");
				}else{
					$(this).addClass('animate');
					$(this).css("display", "block");
				}


			});
			// end of AREA loop


		// ***************************
		// Brand、Area、Steteのすべてが指定されている
		// ***************************
		}else if (brand != '' && area != '' && state != ''){

			// loop of AREA
			let areaElements = $('.area-wrapper');
			areaElements.each(function(index) {

				let showAreaFlg = false;

				if($(this).hasClass(area)){

					showAreaFlg = true;

					// loop of COUNTRY
					let countryElements = $(this).find('.country-wrapper');
					countryElements.each(function(index) {

						let showCountryFlg = false;

						// loop of STATE
						let StateElements = $(this).find('.state-wrapper');
						StateElements.each(function(index) {

							let showStateFlg = false;

							if($(this).hasClass(state)){
//							if($(this).is("[data-category='" + state + "']")){

								// loop of STORE
								let storeElements = $(this).find('li');
								storeElements.each(function(index) {

									let showStoreFlg = false;

									if($(this).hasClass(brand)){
//									if($(this).is("[data-category*='" + brand + "']")){
										// Store
										showStoreFlg = true;
										// State
										showStateFlg = true;
										// Area
										showAreaFlg = true;
										// Country
										showCountryFlg = true;
									}

									// Store
									if(!showStoreFlg){
										$(this).removeClass('animate');
										$(this).css("display", "none");
									}else{
										$(this).addClass('animate');
										$(this).css("display", "block");
									}


								});

								// State
								if(!showStateFlg){
									$(this).removeClass('animate');
									$(this).css("display", "none");
								}else{
									$(this).addClass('animate');
									$(this).css("display", "block");
								}

							}

						});
						// end of STATE loop


						if(!showCountryFlg){
							$(this).removeClass('animate');
							$(this).css("display", "none");
						}else{
							$(this).addClass('animate');
							$(this).css("display", "block");
						}


					});
					// end of COUNTRY loop
				}

				if(!showAreaFlg){
					$(this).removeClass('animate');
					$(this).css("display", "none");
				}else{
					$(this).addClass('animate');
					$(this).css("display", "block");
				}


			});
			// end of AREA loop

		}else{
			return;
		}


	}






	function getBrandFilterString(mm, mmak){

		if(mm === '1' && mmak === '1'){
			return 'MM MMAK';
		}else if(mm === '1'){
			return 'MM';
		}else if(mmak === '1'){
			return 'MMAK';
		}
		return '';

	}

	function getCountryString(country){

		let result = '';

		switch (country) {
		case 'US':
			result = 'United States';
			break;
		case 'JP':
			result = 'JAPAN';
			break;
		case 'CN':
			result = 'CHINA';
			break;		
		case 'BE':
			result = 'BELGIUM';
			break;
		case 'CH':
			result = 'SWITZERLAND';
			break;
		case 'FR':
			result = 'FRANCE';
			break;
		case 'IT':
			result = 'ITALY';
			break;
		case 'PT':
			result = 'PORTUGAL';
			break;
		case 'NZ':
			result = 'NEW ZEALAND';
			break;
		case 'AU':
			result = 'AUSTRALIA';
			break;
		case 'UK':
			result = 'UNITED KINGDOM';
			break;
		case 'AT':
			result = 'AUSTRIA';
			break;		
		case 'ES':
			result = 'SPAIN';
			break;
		default:
		}
		return result;
	}

	function isStateChanged(state, lastState){
		if(state != lastState){
			return true;
		}
		return false;
	}

	function isCountryChanged(country, lastCountry){
		if(country != lastCountry){
			return true;
		}
		return false;
	}


	function isAreaChanged(area, lastArea){
		if(area != lastArea){
			return true;
		}
		return false;
	}





	function isEuCountry(country){


		const EUCountries = ["AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE", "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT", "RO", "SK", "SI", "ES", "SE"];

		let result = EUCountries.includes(country);

		return result;
	}

/*
	function getAreaString(country){

		let result = '';

		if(country == 'US'){
			result = 'US';
		}else if(isEuCountry(country)){
			result = 'EU';
		}else if(country == 'JP'){
			result = 'ASIA';
		}else{
			strAreaFilter = 'OTHERS';
		}
		return result;

	}
*/




/*  ###  control open and close button ###*/

$(function() {
	$('a#map-btn').on('click', function(){

console.log("cliked");
		
		$('body').addClass('shoplist-open');
		$('body').addClass('no-scroll');
		return false;
	});
});

/* close */
$(function() {
	
	$('#shoplist-overlay').on('click', function(){
		
		$('body').removeClass('shoplist-open');
$('.shoplist-option').removeClass('option-open');
		$('body').removeClass('no-scroll');
		return false;
	});
	
	$('#shoplist-close > span').on('click', function(){
		
		$('body').removeClass('shoplist-open');
$('.shoplist-option').removeClass('option-open');
		$('body').removeClass('no-scroll');
		return false;
	});
	
	
	
});



/*  ###  control option ###*/
$(function() {
	$('.shoplist-option').on('click', function(){

console.log("option cliked");

console.log($(this).siblings('.shoplist-option').length);
$(this).siblings('.shoplist-option').removeClass('option-open')

		
		$(this).toggleClass('option-open');
		return false;
	});
});

















});